import { Empty } from 'antd';

import { Table } from '@atom/table/table';
import { PaginationCursor } from '@component/pagination/pagination-cursor';
import { isExist } from '@util/data/is-exist';

import { requestLogsColumns } from './application-logs.options';
import { requestSubLogs } from './request-sub-logs/request-sub-logs';
import { useRequestLogs } from './use-application-logs.hook';

interface RequestLogsProps {
  isLoading?: boolean;
  currentConsumerId?: string;
}

export const ApplicationLogs = ({ isLoading }: RequestLogsProps) => {
  const { data, isLoading: isLoadingLogs, pagination, onNext, onPrevious } = useRequestLogs();

  return (
    <Table
      columns={requestLogsColumns}
      dataSource={data}
      expandable={{ expandedRowRender: requestSubLogs }}
      loading={isLoading || isLoadingLogs}
      pagination={false}
      rowKey='id'
      footer={
        isExist(pagination)
          ? () => <PaginationCursor pagination={pagination} onNext={onNext} onPrevious={onPrevious} />
          : undefined
      }
      locale={{
        emptyText: <Empty description='No logs' image={Empty.PRESENTED_IMAGE_SIMPLE} />,
      }}
    />
  );
};
